import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { InputNumberModule } from 'primeng/inputnumber';
import { PasswordModule } from 'primeng/password';
import { requireFormControl } from '../../forms';

@Component({
  selector: 'prime-input-password',
  templateUrl: './prime-input-password.component.html',
  styleUrls: ['./prime-input-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InputNumberModule, ReactiveFormsModule, PasswordModule],
  encapsulation: ViewEncapsulation.None,
})
export class PrimeInputPasswordComponent {
  readonly feedback = input(true);
  readonly autofocus = input(false);
  readonly toggleMask = input<boolean>();
  readonly inputStyleClass = input<string>();
  readonly autocomplete = input<string>();
  readonly tabindex = input<number>();

  readonly control = input.required({ transform: requireFormControl });
}
